module.exports = __webpack_public_path__ + "img/learn-and-teach.e9ef3029.svg";